import { render, staticRenderFns } from "./PagePicker.vue?vue&type=template&id=40b56661&"
import script from "./PagePicker.vue?vue&type=script&lang=js&"
export * from "./PagePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports